import { mostrarIdioma } from '@/utils/funciones_auxiliares.js';
export const restSinNegocio = (obj) => {
	return obj.id.replace(obj.negocio + '-', '');
}
export const restSinNegocioParams = (rest, negocio) => {
	return rest.replace(negocio + '-', '');
}
export const formatearCocinas = (obj, cocinas) => {
	let res = "";
	if (cocinas != undefined) {
		obj.forEach((e, i) => {
			let separador = i == obj.length - 1 ? "" : " • ";
			let index = cocinas.findIndex((x) => { return x.id == e })
			res += (mostrarIdioma(cocinas[index].nombre) + separador);
		})
	}
	return res;
}